import GearHeadings from "../../ui/gearheadings";
import GearButton from "../../ui/gearbutton";
import { useTranslation } from "react-i18next";
import { GearPal } from "../../types/Pal";
import { useUserAddress } from "../../components/providers/ModalsProvider";
import { IoLocationOutline } from "react-icons/io5";

interface UserAddressProps {
  gearpalsData: GearPal[];
}

export default function UserAddress({ gearpalsData }: UserAddressProps) {
  const { t } = useTranslation();
  const { open: openUserAddressModal } = useUserAddress();
  return (
    <div className="profile-card pt-6 relative">
      <GearHeadings variant="h3" className="text-secondary mb-4">
        {t("pages.profile.yourAddress", "Il tuo indirizzo")}
      </GearHeadings>
      <GearButton
        variant="ghost"
        size="small"
        className="text-primary hover:text-primary/80 absolute top-4 right-4"
        onClick={() => openUserAddressModal(true, gearpalsData[0])}
      >
        <img src="/icons/editblue.svg" alt="edit" className="w-5 h-5" />
      </GearButton>
      <div className="flex flex-col gap-4">
        {gearpalsData?.length === 0 && (
          <GearButton
            size="small"
            variant="secondary"
            className="!rounded-full font-bold shadow-lg shadow-secondary/20 hover:shadow-secondary/30 transition-all active:scale-95"
            onClick={() => openUserAddressModal(true, gearpalsData[0])}
          >
            {t("pages.profile.addAddress", "Aggiungi indirizzo")}
          </GearButton>
        )}
        {gearpalsData?.map((pal) => (
          <div
            key={pal.id}
            className="flex items-center  gap-5 rounded-2xl p-3 md:p-5 bg-[#2C1A4A]/30 border border-white/5 hover:border-white/10 transition-colors"
          >
            <div className="flex-shrink-0 p-3 rounded-full bg-primary/10 text-primary">
              <IoLocationOutline size={24} />
            </div>
            <div className="flex flex-wrap gap-2">
              <span className="text-white font-semibold text-lg tracking-wide leading-relaxed">
                {pal.name}
              </span>
              <div className="flex flex-wrap text-white/70 gap-1 text-base leading-relaxed mt-0.5">
                <span className="md:text-md text-sm">
                  {pal.city} <span className="text-white/40">•</span>{" "}
                  {pal.zipCode}
                </span>
                <span className="md:text-base text-sm">{pal.country}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
